import client from '../../../utils/api'
import { createApiAction } from '../../../utils/redux-tool'

const basePath = '/api/student/:memberId/contact'

export const save = createApiAction('academic/parent/contact/save', client.save(basePath))
export const destroy = createApiAction('academic/parent/contact/destroy', client.destroy(`${basePath}/:id`))
export const saveSequences = createApiAction(
  'academic/parent/contact/re-order',
  client.save(`${basePath}/re-order`),
)
